const modal = document.querySelector(".cesde-modal-operator");
const cesde_operator = document.querySelector(".cesde-operator");
const cesde_operator_close = document.querySelector(".cesde-operator-close");
const buttonTrigger = document.getElementById("button-trigger");
const socialWidget = document.getElementById("social-widget");
const buttonListWrapper = document.querySelector(".button-list-wrapper");

if (modal) {
  cesde_operator.addEventListener("click", () => {
    if (!modal.classList.contains("active")) {
      modal.classList.add("active");
    } else {
      modal.classList.remove("active");
    }
  });
  cesde_operator_close.addEventListener("click", () => {
    modal.classList.remove("active");
  });
}
if (buttonTrigger) {
  buttonTrigger.addEventListener("click", () => {
    if (!socialWidget.classList.contains("open")) {
      socialWidget.classList.add("open");
      //.rotateButton
      buttonTrigger.classList.add("rotateButton");
      buttonTrigger.innerHTML = '<i class="fas fa-times"></i>';
      setTimeout(() => {
        buttonTrigger.classList.remove("rotateButton");
      }, 700);
    } else {
      socialWidget.classList.remove("open");
      buttonTrigger.classList.add("rotateButton");
      buttonTrigger.innerHTML = '<i class="fa-solid fa-comments"></i>';
      setTimeout(() => {
        buttonTrigger.classList.remove("rotateButton");
      }, 700);
    }
  });
}
document.addEventListener("scroll", () => {
  if (window.scrollY > 300) {
    buttonListWrapper.style.right = "18px";
  } else {
    buttonListWrapper.style.right = "-100px";
  }
});
